const useSharedLink = () => {
    //Production Server URL in constant file
  const sharedLink = "https://insightabanotes-dmg4fpdcfrhwfwfx.canadaeast-01.azurewebsites.net"; // Your shared link

  // Lucid Dev Server
 // const sharedLink = "http://localhost:8080"; // Your shared link

  // You can add any related logic here if needed

  return sharedLink;
};

export default useSharedLink;
